import '@fontsource/poppins/300.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/700.css';

import { cyan, grey, yellow } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';
import { gridClasses } from '@mui/x-data-grid-pro';
import '@mui/x-data-grid-pro/themeAugmentation';
import { LicenseInfo } from '@mui/x-license-pro';

// Set the license key
LicenseInfo.setLicenseKey(import.meta.env.VITE_MUIX_LICENSE_KEY as string);

declare module '@mui/material/styles' {
  interface TypeBackground {
    base: TypeBackground['default'];
  }
}

const theme = createTheme({
  typography: {
    fontFamily: 'Poppins, sans-serif',
  },
  palette: {
    primary: {
      main: cyan[500],
      contrastText: grey[50],
    },
    secondary: yellow,
    background: {
      base: grey[50],
    },
  },
  components: {
    MuiSnackbarContent: {
      styleOverrides: {
        root({ theme: _theme }) {
          return {
            backgroundColor: _theme.palette.background.paper,
            color: _theme.palette.text.primary,
            borderRadius: '16px',
            padding: '14px 24px',
          };
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: grey[100],
        },
      },
    },
    MuiInputLabel: {
      defaultProps: { shrink: true },
    },
    MuiOutlinedInput: {
      defaultProps: {
        notched: true,
      },
      styleOverrides: {
        root: {
          borderRadius: 16,
          backgroundColor: 'white',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 16,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 16,
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip({ theme: _theme }) {
          return {
            backgroundColor: _theme.palette.background.base,
            color: _theme.palette.text.primary,
            borderRadius: 16,
            boxShadow: _theme.shadows[3],
            padding: '8px 16px',
          };
        },
        arrow({ theme: _theme }) {
          return {
            color: _theme.palette.background.base,
          };
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root({ theme: _theme }) {
          return {
            backgroundColor: _theme.palette.background.paper,
            borderRadius: 16,
            [`
              & .${gridClasses.columnHeaders},
              & .${gridClasses.pinnedColumnHeaders}
            `]: {
              backgroundColor: _theme.palette.background.base,
            },
          };
        },
      },
    },
  },
});

export default theme;
